<template>
  <zm-alert
      class="opc-soft-bundle-alert-message"
      :closable="false"
      v-if="visible"
    >
      <template #icon>
        <div class="opc-soft-bundle-alert-message__icon">
          <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9 17.75C10.1953 17.75 11.319 17.5212 12.3713 17.0637C13.4293 16.6062 14.3615 15.9743 15.1679 15.1679C15.9743 14.3615 16.6062 13.4322 17.0637 12.3799C17.5212 11.3219 17.75 10.1953 17.75 9C17.75 7.80474 17.5212 6.68096 17.0637 5.62868C16.6062 4.57067 15.9743 3.63848 15.1679 2.83211C14.3615 2.02574 13.4293 1.39379 12.3713 0.936274C11.3133 0.478758 10.1867 0.25 8.99142 0.25C7.79616 0.25 6.66953 0.478758 5.61152 0.936274C4.55923 1.39379 3.6299 2.02574 2.82353 2.83211C2.02288 3.63848 1.39379 4.57067 0.936274 5.62868C0.478758 6.68096 0.25 7.80474 0.25 9C0.25 10.1953 0.478758 11.3219 0.936274 12.3799C1.39379 13.4322 2.02574 14.3615 2.83211 15.1679C3.63848 15.9743 4.56781 16.6062 5.6201 17.0637C6.6781 17.5212 7.80474 17.75 9 17.75ZM7.45588 13.9583C7.27288 13.9583 7.11846 13.9011 6.99265 13.7868C6.86683 13.6667 6.80392 13.5151 6.80392 13.3321C6.80392 13.1605 6.86683 13.0147 6.99265 12.8946C7.11846 12.7688 7.27288 12.7059 7.45588 12.7059H8.54534V8.66544H7.60172C7.42443 8.66544 7.27288 8.60825 7.14706 8.49387C7.02124 8.37377 6.95833 8.22222 6.95833 8.03922C6.95833 7.86765 7.02124 7.72181 7.14706 7.60172C7.27288 7.4759 7.42443 7.41299 7.60172 7.41299H9.26593C9.49469 7.41299 9.66626 7.48734 9.78064 7.63603C9.90073 7.78472 9.96078 7.97917 9.96078 8.21936V12.7059H11.0502C11.2333 12.7059 11.3877 12.7688 11.5135 12.8946C11.6393 13.0147 11.7022 13.1605 11.7022 13.3321C11.7022 13.5151 11.6393 13.6667 11.5135 13.7868C11.3877 13.9011 11.2333 13.9583 11.0502 13.9583H7.45588ZM8.92279 5.94608C8.60253 5.94608 8.32802 5.83456 8.09926 5.61152C7.87623 5.38276 7.76471 5.10825 7.76471 4.78799C7.76471 4.46201 7.87623 4.1875 8.09926 3.96446C8.32802 3.7357 8.60253 3.62132 8.92279 3.62132C9.24877 3.62132 9.52042 3.7357 9.73775 3.96446C9.96078 4.1875 10.0723 4.46201 10.0723 4.78799C10.0723 5.10825 9.96078 5.38276 9.73775 5.61152C9.52042 5.83456 9.24877 5.94608 8.92279 5.94608Z" fill="#2884F6"/>
          </svg>
        </div>
      </template>
      <div>
        <span class="zm-alert__title is-bold opc-soft-bundle-alert-message__title">{{ $t(messageInfo.title) }}</span>
        <span slot="default" class="opc-soft-bundle-alert-message__desc">
          {{ $t(messageInfo.description) }}
          <zm-tooltip :content="$t(messageInfo.tips)" placement="top">
            <zm-button type="icon" icon="zm-icon-info-outline" ghost class="opc-soft-bundle-alert-message__desc-icon-btn"></zm-button>
          </zm-tooltip>
        </span>
      </div>
    </zm-alert>
</template>

<script>
import { mapGetters } from 'vuex';
import ZmAlert from '@/components/zoom-ui-plus/alert/alert.vue';
import { getSoftBundleMessages } from '../helper';
import { couponFetchStatus } from '@/views/config/coupon/helper/constant';

export default {
  name: 'SoftBundleAlertMessage',
  components: {
    ZmAlert,
  },
  computed: {
    ...mapGetters(['softBundleConfiguration', 'softBundleState', 'getSelectedPlans']),
    softBundlePlanConfig() {
      return this.softBundleConfiguration?.["config"];
    },
    visible() {
      return this.softBundlePlanConfig?.showOfferBanner && !!this.messageInfo.title && this.isEligible;
    },
    lastStatusIsSuccess() {
      return this.softBundleState.lastStatus === couponFetchStatus.successfully;
    },
    isEligible() {
      return this.getSelectedPlans?.length > 0 && (this.softBundleState.isSuccess || (this.lastStatusIsSuccess && this.softBundleState.isPending));
    },
    messageInfo() {
      return getSoftBundleMessages(this.softBundleState?.bundleName);
    }
  },
};
</script>

<style lang="scss">
.opc-soft-bundle-alert-message__skeleton {
  margin-bottom: 16px;
  .zm-skeleton {
    .zm-skeleton__item {
      margin-top: 5px;

      &:nth-of-type(1) {
        width: 50%;
      }

      &:nth-of-type(2) {
        width: 80%;
      }
    }
  }
}


.opc-soft-bundle-alert-message {
  color: #2A2B2D;
  border-radius: 8px;
  background: #F2F8FF;
  margin-bottom: 16px;

  .zm-alert__description {
    display: flex;
    align-items: flex-start;
  }

  &__icon {
    margin-right: 8px;
  }

  &__title {
    font-size: 16px;
    font-weight: 600;
    line-height: 20px;
    letter-spacing: -0.31px;
    margin-bottom: 2px;
  }

  &__desc {
    font-size: 14px;
    font-weight: 400;
    line-height: 18px; /* 128.571% */
    letter-spacing: -0.15px;

    &-icon-btn {
      &.zm-button.zm-button--small {
        padding: 0;
        margin-left: 2px;
        min-width: auto;
        color: #666487 !important;
      }
    }
  }
}
</style>
